import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-common-component-dropdown-search',
  templateUrl: './common-component-dropdown-search.component.html',
  styleUrls: ['./common-component-dropdown-search.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatIcon],
})
export class CommonDropdownSearchComponent implements OnInit, OnChanges {
  @Output() itemSelected = new EventEmitter<string>();
  @Input() items: { key: string; value: string }[] = [];
  @Input() initialValue: string | null = null;
  @Input() placeHolder: string | null = null;

  searchForm = new FormGroup({
    searchInput: new FormControl(''),
  });

  dropdownVisible = false;
  filteredItems: { key: string; value: string }[] = [];
  selectedItem: { key: string; value: string } | null = null;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.updateFilteredItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && changes['items'].currentValue) {
      this.updateFilteredItems();
    }
  }

  updateFilteredItems(): void {
    this.filteredItems = [...this.items]; // Ensure a fresh reference
    if (this.initialValue) {
      this.selectedItem =
        this.items.find((item) => item.value === this.initialValue) || null;
    }
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownVisible = !this.dropdownVisible;
    if (!this.dropdownVisible) {
      this.resetSearch();
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick(event: MouseEvent): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.dropdownVisible = false;
      this.resetSearch();
    }
  }

  onEnterPress(event: KeyboardEvent): void {
    event.preventDefault();
    this.filterItems();
  }

  clearSelection(event: MouseEvent): void {
    event.stopPropagation(); // Prevent dropdown toggle
    this.selectedItem = null;
    this.itemSelected.emit('');
    this.resetSearch();
  }

  private filterItems(): void {
    const searchTerm =
      this.searchForm.get('searchInput')?.value?.trim().toLowerCase() || '';

    this.filteredItems = this.items.filter((item) => {
      if (!item.key) {
        console.warn('Item with null/undefined key found:', item);
        return false; // Exclude items with null/undefined key
      }
      return item.key.toLowerCase().includes(searchTerm);
    });
  }

  onItemSelect(item: { key: string; value: string }): void {
    this.selectedItem = item;
    this.itemSelected.emit(item.value);
    this.dropdownVisible = false;
    this.resetSearch();
  }

  private resetSearch(): void {
    this.filteredItems = this.items;
    this.searchForm.get('searchInput')?.setValue('');
  }

  onContainerClick(event: MouseEvent): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.dropdownVisible = false; // Close the dropdown if clicked outside
    }
  }
}
